import {TokenHandling} from './TokenHandling';

export default TokenHandling;
